import Parse from "parse";
import { useEffect, useState } from "react";
import { Issuecategory } from "../../../../js/parsegenerated";

export interface IssueCategory_Default_DataType {
  key: string;
  enabled?: boolean;
  catchall?: boolean;
  code?: string;
  name: string;
  children?: IssueCategory_Default_DataType[];
}

export interface IssueCategory_TreeSelect_DataType {
  key: string;
  title: string;
  value: string;
  catchall?: boolean;
  children?: IssueCategory_TreeSelect_DataType[];
  disabled?: boolean;
  disableCheckbox?: boolean;
  selectable?: boolean;
  checkable?: boolean;
}

/**
 *
 * @returns Provides the data of class "Issuecategory" as an object to be used in antd <SelectTree /> component.
 */
export function useIssueCategoryTreeSelectData(
  selectedcategory?: IssueCategory_Default_DataType
) {
  const [loading, setLoading] = useState(true);
  const [treeData, setTreeData] = useState<IssueCategory_TreeSelect_DataType[]>(
    []
  );
  const [reload, setReload] = useState(0);

  const findchildren = (
    values: Issuecategory[],
    id_1: string
  ): IssueCategory_TreeSelect_DataType[] | undefined => {
    const _categories = values
      .filter((x: Issuecategory) => {
        return x.get("parent") ? true : false;
      })
      .filter((y: Issuecategory) => {
        return y.get("parent")?.id === id_1;
      })
      .map((z: Issuecategory) => {
        return {
          key: z.id,
          title: `${z.get("issuecode") || "-"} ${z.get("name")}`,
          value: z.id,
          catchall: z.get("catchall"),
          children: findchildren(values, z.id),
          disabled: selectedcategory?.key === z.id,
        };
      });

    return _categories.length > 0 ? _categories : undefined;
  };

  useEffect(() => {
    setLoading(true);
    new Parse.Query(Issuecategory)
      .equalTo("enabled", true)
      .include("parent")
      .find()
      .then((values: Issuecategory[]) => {
        const _data = values
          .filter((category: Issuecategory) => {
            return category.get("parent") ? false : true;
          })
          .map((x: Issuecategory): IssueCategory_TreeSelect_DataType => {
            return {
              key: x.id,
              title: `${x.get("issuecode") || "-"} ${x.get("name")}`,
              value: x.id,
              catchall: x.get("catchall"),
              children: findchildren(values, x.id),
              disabled: selectedcategory?.key === x.id,
            };
          });

        setTreeData(_data);
        setLoading(false);
      });
  }, [selectedcategory, reload]);

  return [
    treeData,
    setTreeData,
    () => {
      setReload((x) => x + 1);
    },
    loading,
  ] as [
    IssueCategory_TreeSelect_DataType[] | undefined,
    React.Dispatch<
      React.SetStateAction<IssueCategory_TreeSelect_DataType[] | undefined>
    >,
    () => void,
    boolean,
  ];
}
